<template>
  <!-- https://michalsnik.github.io/aos/ -->
  <v-container>
    <v-card class="mx-auto" max-width="550">
      <v-system-bar  color="pink darken-2" @click.stop="$router.push('/home')">
        <v-icon>home</v-icon>
      </v-system-bar>
    

        <v-app-bar color="#424242" dark dense @click.stop="$router.push('/home')">
           <v-toolbar-title>Scheduled Sets</v-toolbar-title>
        </v-app-bar>
            <v-row class="d-flex justify-center align-center text-body-1 cGrey--text text-center  ma-1 pa-1 grey--text">

            If you subscribe to Notifications you receive hourly links to Sets                  
        </v-row>
            <v-row class="d-flex justify-center align-center text-body-1 cGrey--text text-center  ma-1 pa-1 grey--text">

            Personalise your Schedule by choosing the Set for each hour           
        </v-row>

        <v-row class="d-flex justify-center align-center text-h6 text-center ma-1 pa-1 grey--text">
            Your daily Set list - <v-icon left>mdi-clock-outline </v-icon>notification times
        </v-row>

 
<v-divider></v-divider>

<!--
  SCHEDULE A SET FORM
-->


      <div class="custom-card">
      <v-overlay position: absolute :opacity=0.7 :value=displayAddFormFlag max-width="500px">
        <v-card class="custom-card"  width="850">
       
              <v-row align="center" class="d-flex dark flat">
                <v-col cols="12">
                  <template>
                    <v-select
                      v-model="selectedSetName"
                      :items="setListWithDefault"
                      label="Select a Set"
                      item-text="label"
                      item-value="value"
                    >
                      <template v-slot:item="{ item }">
                        <div>
                          <div>{{ item.label }}</div>
                            <template v-for="(child, index) in item.exercises">
                                <span :key="index" class="ma-2 ml-2 pa-0 grey--text">{{child.title}} </span>
                                
                            </template>
                        </div>
                      </template>
                    </v-select>
                  </template> 
                </v-col>
              </v-row>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat color="grey darken-1" @click="updateUserSchedule(selectedSetName)">Select this Set</v-btn>
              <v-spacer></v-spacer>                             
              <v-btn flat color="grey darken-1" @click="cancelSet()">Cancel</v-btn>
                <v-spacer></v-spacer>                                   
            </v-card-actions>      
         
        </v-card>
      </v-overlay>

      </div>


<!-- UPDATE CONFIRMATION -->

      <div class="custom-card">
      <v-overlay position: absolute :opacity=0.7 :value=displayUpDateConfirmation max-width="500px">
        <v-card class="custom-card"  width="850">
        
          <v-card-text>
            <p class="ma-0 pa-0 text-h6 text-center" >Notification Schedule has been updated</p>
            
            <p class="ma-0 pa-0 text-body-1 text-center" >Notifications received for {{selectedHourSet.hour}} will link to {{selectedHourSet.set}}</p>

          </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>                          
              <v-btn flat color="grey darken-1" @click="closeUpdateConfirmationModal()">Close</v-btn>
                <v-spacer></v-spacer>                                   
            </v-card-actions>      
    
        </v-card>
      </v-overlay>

      </div>


<!-- NEW CODE-->

    <v-row dense>  

  
  <!-- SCHEDULED SETS -->    

  <!--https://vuetifyjs.com/en/components/list-item-groups/ -->  

      <v-col   cols="12" >

        <v-list class="ma-0 pa-0">
              <v-list-group
                v-for="(item, index) in displaySchedule"
                :key="index"
                v-model="item.isOpen"
                color="pink darken-2"
                mandatory
                active-class="bg-active"
                no-action
                @click="setDisplayScheduleIndex(index)"
              >
  
                <template v-slot:activator>
                  <v-list-item-content               
                  color="primary"
                  >
                  <v-chip class="ma-0" color="pink" label  text-color="white">
                    <v-icon left>mdi-clock-outline </v-icon>{{item.displayHour}}
                  </v-chip>
                    <v-list-item-title class="mt-2 pl-4" v-text="getSetTitle(index)" ></v-list-item-title>
                
                  </v-list-item-content>
                </template>
            

                  <template v-for="(child, index) in item.exercises">
                    <ul :key="index">
                      <li class="ma-2 ml-10 pa-0 grey--text">{{child.title}}</li>
                    </ul>
                  </template>

              <!-- append Actions -->
                  <v-row  dense  color="pink darken-2">  
                    <v-col  cols="4"></v-col>
                    <v-col  cols="4">
                      <div class="text-xs-center">
                        <v-card-actions class="justify-center" >
                            <v-btn light  class="mr-10"  color="pink darken-2 white--text" small @click="displayAddForm(item.id)" >
                              <span>Change Set</span>
                              <v-icon>change_circle</v-icon>
                            </v-btn> 
                          <v-spacer></v-spacer>  
                            <v-btn light color="pink darken-2 white--text" small    @click="goToSession" :right="true" :absolute="true">
                              <span>Start Session</span>
                              <v-icon>play_circle</v-icon>

                            </v-btn> 
                            <v-spacer></v-spacer>
                           
                        </v-card-actions>
                      </div>
                    </v-col>
                    <v-col  cols="4"></v-col>
                </v-row>  
                <v-divider></v-divider>

              </v-list-group>
            </v-list>
           
          </v-col>
    </v-row>

<v-divider></v-divider>
      <v-row dense>  

        <v-col cols="12" >
       
            <div>
              <div>
                <v-card-text class="ma-2 pa-0">
                    <p class="ma-0 ml-2 mr-2 pa-0 text-center">By default, Notifications link to Microcise recommended Sets </p>
                     <p class="mt-0 mr-1 pa-0 text-center"><b>Select a time to customise your Schedule</b></p>
                </v-card-text>

              </div>
            </div>
         
         </v-col>

      </v-row>  

      <v-row dense>  

          <v-col cols="12" >
         
              <div>
                <div>
                  <v-card-title class="text-h6  text-center grey--text text--darken-2 blue lighten-5">
                  <v-spacer></v-spacer>
                  Hourly Notifications   <v-icon medium color="grey darken-2" >notifications</v-icon>
                  <v-spacer></v-spacer>
                  </v-card-title>
  
                  <v-card-text class="ma-2 pa-0">
                    <p class="ma-0 ml-2 mr-2 pa-0 text-center"><b>Get hourly desktop notifications for Stretch, Move and Strength exercises</b></p>
                    <p class="mt-0 mr-1 pa-0 text-center">Gentle reminders to do 2-3 minutes of stretching or movement.</p>
                                         
                      <p class="mt-0 mr-1 pa-0  text-body-1 cGrey--text text-center">     
                      <b>The easiest way Microcise - <a href="#" @click.stop="NotificationsModal = true">subscribe to receive hourly reminders</a></b>
                      </p>


                  </v-card-text>

                </div>
              </div>
           
           </v-col>

        </v-row>




<!--
  HOW TO SET NOTIFICATIONS MODAL
-->
  <div class="text-center ">
      <v-dialog

        v-model="NotificationsModal"
        width="600"
      >
        <v-card>
          <v-card-title class="text-h4 grey lighten-2">
            Microcise Notifications
          </v-card-title>
  
          <v-card-text>
            <p class="ma-0 pa-0 text-h6 text-center" >We all need a little help forming a new habit</p>
            
            <p class="ma-0 pa-0 text-body-1 text-center" >You will receive regular reminders to exercise every hour between 9am to 5pm week days. Our users find this a great way to get into the routine of frequent movement and exercise.</p>

          </v-card-text>
          
          <v-divider></v-divider>

          <!-- v-card-text>
            <p class="ma-0 pa-0 text-body-1  text-center" >Microcise Notifications appear alongside other system notifications. You do not have to have the Microcise web site, or even your browser, open!</p> 
         
            <p class="ma-0 pa-0 text-body-1  text-center" ></p>
          </v-card-text -->


          <v-card-text>
            <p class="ma-0 pa-0 text-h6 text-center pink--text text--darken-2" >Click the bell icon* at the bottom right of the HOMEPAGE to subscribe to Microcise notifications</p>
                 

            <v-row  dense>  
          <v-col  cols="5" >
          </v-col>
          <v-col  cols="5" >
              <v-img max-height="50" max-width="50" position="center center" src="/icons/bell_prompt.png"></v-img>
          </v-col>
          <v-col  cols="5" >
          </v-col>  
          </v-row>        
            <p class="ma-0 pa-0 text-body-1 text-center" >Click again to unsubscribe</p>  
            <p class="ma-0 pa-0 body-2 text-center" >*Notifications do not work with Apple Mobile/iPad (iOS) and the icon will not appear</p>
           
        </v-card-text>
        <v-divider></v-divider>
  
          <v-card-actions>
                        <v-spacer></v-spacer>
            <v-btn light   color="pink darken-2outlined  white--text" small @click="$router.push('/home')" >
                              <span>Homepage</span>
                              <v-icon>home</v-icon>
                            </v-btn> 
                          <v-spacer></v-spacer>  


            <v-btn
              class="ma-2 pa-0 text-center"
              color="primary"
              text
              @click="NotificationsModal = false"
            >
              close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>

    </v-card>
    <v-navigation-drawer
     class="grey lighten-4"
      v-model="drawer"
      absolute
      bottom
      temporary
    >
      <v-list
        nav
        dense
      >
        <v-list-item-group
          v-model="group"
          active-class="deep-purple--text text--accent-4"
        >
          <v-list-item @click="$router.push('/')">
            <v-list-item-icon>
              <v-icon>home</v-icon>
              <span>Home</span>
            </v-list-item-icon>        
          </v-list-item>

          <v-list-item @click="$router.push('/sets')">
            <v-list-item-icon>
              <v-icon>list</v-icon>
              <span>Sets</span>
            </v-list-item-icon>    
          </v-list-item>

          <v-list-item @click="$router.push('/')">
            <v-list-item-icon>
              <v-icon>schedule</v-icon>
              <span>Schedule</span>
            </v-list-item-icon>   
          </v-list-item>

        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

  </v-container>

</template>



<style>
.v-progress-circular {
margin: 1rem;
}
</style>



<script>
import { Auth } from 'aws-amplify'  
import queries from '../api/queries'

const DEFAULT_SET = "Use Default Set for this hour";
const SCHEDULED_HOURS = [{ '08': '07:55' }, { '09': '08:55' }, {'10': '09:55' }, { '11': '10:55' }, {'12': '11:55' }, { '13': '12:55' },
                    { '14': '13:55' }, { '15': '14:55' }, {'16': '15:55' }, { '17': '16:55' }
                    ];

export default {

  name: 'Sets',

  data: () => ({
    scheduledHours: SCHEDULED_HOURS,
    displayUpDateConfirmation: false,
    selectedHourSet: {},
    displayAddFormFlag: false,
    NotificationsModal: false,
    userSchedule: [],
    defaultSchedule: [],
    displaySchedule: [], // we build this for display
    setChoices: [],
    setSelected: 0,  // not used - remove
    displayScheduleIndex: null,
    scheduleSetToUpdate: null,
    selectedSetName: null,
    panelsOpen: 1,
    links: [],
    drawer: false,
    group: null,
    removeDialog: false,
    setList: [],  // the list of current Sets
    microciseSetList: []
  
  }),
  async created() {

    this.userAuthData = await Auth.currentUserInfo();
    // IF no auth data - redirect to login
     
    this.setList = await queries.listSetExercisesForOwnerAndMicrocise(this.userAuthData.username); // a custom query

    // Get the combined Schedule - User Schedule and Default Schedule combined
    // Setlist is needed to lookup some of the Set details
    this.displaySchedule = await queries.getUsersSchedule(this.scheduledHours, this.setList)

  },
  updated() {

    const self = this;

    // lets check on load if the user is subscribed....
      this.$OneSignal.isPushNotificationsEnabled(function(isEnabled) {
          console.log("OneSignal Check......")
        if (isEnabled) {
          console.log("USER IS SUBSCRIBED")
          self.userSubscribed=true       
        
        }
        else {
          console.log("USER IS NOT SUBSCRIBED")
          self.userSubscribed=false   
        }
         
      });
        
  },  
  computed: {
  
    isPushEnabled() {
      // lets check on load if the user is subscribed....
      this.$OneSignal.isPushNotificationsEnabled(function(isEnabled) {
          console.log("OneSignal Check......")
        if (isEnabled) {
          console.log("USER IS SUBSCRIBED")
          self.userSubscribed=true       
        
        }
        else {
          console.log("USER IS NOT SUBSCRIBED")
          self.userSubscribed=false   
        }
         
      });

      return(self.userSubscribed)

    },
    setListWithDefault() {
      return [
        { label: DEFAULT_SET },
        ...this.setList. map(set => (
          { label: set.title,
            exercises: set.exercises, 
            value: set.setID
        })),
      ];
    },
    selectedCustomSet() {

      if (this.selectedSetName !== null) {
        const setDetails = this.setList.find(entry => entry.title === this.selectedSetName);
        return setDetails;
      }
      return null;
    },
  },       
  methods: {
    setDisplayScheduleIndex(index) {

        this.displayScheduleIndex = index

        // Now close all other items that may be open
          this.displaySchedule.forEach(item => {
          item.isOpen = false;
         });
      },
      goToSession() {
        this.$router.push({ path: 'session', query: { setID: this.setList[this.setSelected].id } })
      },  
      getSetTitle(index) {

        if(this.displaySchedule[index].type == "default") {
          return this.displaySchedule[index].title + " - Default Microcise Set";
        }  else {
          return this.displaySchedule[index].title + " - User selected Set";
        }
        
        },  
      displayAddForm(setBeingDisplayed) {
        this.scheduleSetToUpdate = setBeingDisplayed
        this.displayAddFormFlag=true
      },
      cancelSet() {
        this.displayAddFormFlag=false;
      },
      closeUpdateModal() {
        this.displayAddFormFlag=false;
        this.closeAllItems()
      },
      closeUpdateConfirmationModal() {
        this.displayUpDateConfirmation=false;
        this.closeAllItems()
      },
      closeAllItems() {
        this.displaySchedule.forEach(item => {
          item.isOpen = false;
         });
      },
      // DESCRIPTION
      // A lot going on here. 
      // Display the current Notification Schedule
      // When a user subscribes to Notifications, they receive a notification per hour with a link to a Set of exercises
      // When they first subscribe the Notification Schedule uses a default Set list for the hourly links
      // A user can customise the schedule to select a custom Set for each of the hourly notifications
      // A users Notification Schedule comprises sets from the DefaultScheduleSet (default) and UserScheduledSet (custom) tables 
      // We read the default list of Sets for each our, then overwrite each Set if a custom set for the hour exists     
      // A list of the Set for each hour in the Notification Schedule is then displayed
      // A user may select an entry (hour) in the schedule
      // The user select Set/Hour is captured in the scheduleSetToUpdate attribute 

      // List the current Sets that they may change an entry in the Notification Schedule
      // When a user has selected an entry (hour) in the Notification Schedule
      // They then see a list of ALL available Sets
      // The user can select a new Set to change the current selected Notification Schedule Set/Hour
      // We do not validate if this is a different Set to the one already in this position in the Schedule
      // The user may chose to change to the DEFAULT_SET for this hour
      // We do not validate if the selected set for this slot is already the DEFAULT_SET for this hour
      // The set they want to change to is captured in the selectedCustomSet and its primary key is used later to update 
      // the UserScheduledSet (custom) table

      // LOGIC
      // The user selects a set/hour from the Notification Schedule list
      // The user selects a new Set from the list of all Sets
      // IF the customer has selected 'Use Default Set for this hour' (DEFAULT_SET)
      //  Simply delete the corresponding UserScheduledSet row if it exists      
      // ELSE the customer has selected a set that is not the default set for the selected hour
      //  IF scheduleSetToUpdate is identified as a custom set (type=custom)
      //    update the UserScheduledSet table and change the Set it holds for that hour to selectedCustomSet.id
      //  ELSE
      //    create a new entry in the UserScheduledSet
      //  
      //
      async updateUserSchedule() {

        // Check if the user has selected the default set 
        if(this.selectedSetName===DEFAULT_SET) {
          // nothing selected. This may already be a default set for the selected hour, lets check
          // If this is a default set, there is nothing to do
          // otherwise, a custom set, so remove from the UserScheduledSet
          if(this.displaySchedule[this.displayScheduleIndex].type == 'custom') {
            // remove customer set
            await queries.deleteUserScheduledSet(this.scheduleSetToUpdate);

          } 

          // Used in the UI to tell the user which hour and which set has been updated
          this.selectedHourSet = { 
            hour: this.displaySchedule[this.displayScheduleIndex].displayHour,
            set: "Default Set"
          };

        } else {
          // A user wants to modify a scheduled notification to use a non default Set
          // See if a slot already exists for this user selection in the ScheduleSet table
          // if the Set Type = Custom then a row in the schedule table already exists....
          if(this.displaySchedule[this.displayScheduleIndex].type == 'custom') {
            // we already have a record for this one, update
            await queries.updateUserScheduledSet(this.scheduleSetToUpdate, this.selectedCustomSet.id);

          } else {
            // Row does not exist, create

            let jsonData =  
            '{ "hour": "' + this.displaySchedule[this.displayScheduleIndex].hour  +           
            '" , "userID": "' + this.userAuthData.username +           
            '" , "day": "' + "Monday" +              
            '" , "set": "' + this.selectedCustomSet.id  + 
            '"}';

          const customSetData = JSON.parse(jsonData);  

          await queries.saveUserScheduledSet(customSetData); 
          }

          // Used in the UI to tell the user which hour and which set has been updated
          this.selectedHourSet = { 
            hour: this.displaySchedule[this.displayScheduleIndex].displayHour,
            set: this.selectedCustomSet.title
          };

        }

        // Manage the UI
        this.closeUpdateModal()
        this.displayUpDateConfirmation=true;
      }    
  }          
}
</script>


<style>
.custom-card {
  max-width: 400px; /* Adjust the width as needed */
  width: 100%; /* Ensure the card takes the full width if content is smaller */
  margin: 0 auto; /* Center the card horizontally */
}
</style>


